// extracted by mini-css-extract-plugin
module.exports = {"subNavigation":"_38X2rHKgP4nfgf7k4OGamu","projectSelector":"lbjsx7ItOEZnjZS9PFX0U"};